import { Navigate, Route, Routes } from 'react-router-dom'
import SignIn from '../../features/auth/SignIn'
import { useAppSelector, store } from '../redux/store'
import Admin from '../../features/settings/Settings'
import AuthorizedRoutes from './AuthorizedRoutes'
import { setupInterceptors } from '../api'
import ResetAdminPassword from '../../features/auth/ResetAdminPassword'

setupInterceptors(store)
export default function AppRoutes() {
  const { token } = useAppSelector((state) => state.auth)

  return (
    <Routes>
      {token ? (
        <>
          <Route path="*" element={<AuthorizedRoutes />} />
        </>
      ) : (
        <>
          <Route path="/" element={<SignIn />} />
          <Route path="/admin/reset-password" element={<ResetAdminPassword />} />

          <Route path="*" element={<Navigate to="/" />} />
        </>
      )}
    </Routes>
  )
}
